import axios from "../utils/http";
import path from "./path"

const stringFormat = (formatted, args) => {
    for (let i = 0; i < args.length; i++) {
        let regexp = new RegExp('\\{' + i + '\\}', 'gi')
        formatted = formatted.replace(regexp, args[i])
    }
    return formatted
}
const api = {
    getOssKeySecret() {
        return axios.get(path.baseUrl + path.getOssKeySecret)
    },
    getQueryForm(formId, query) {
        return axios.get(path.baseUrl + path.queryForm[formId], {params: query})
    },
    get(url, query) {
        if(!url.startsWith('http')){
            url = path.baseUrl + url
        }
        if (query) {
            return axios.get(url, {params: query})
        }
        return axios.get(url)
    },
    post(url, data) {
        return axios.post(path.baseUrl + url, data)
    },
    getDialogForm(dataId, bindId) {
        if (bindId != null) {
            return axios.get(path.baseUrl + stringFormat(path.dialogs[dataId], [bindId]))
        }
        return axios.get(path.baseUrl + path.dialogs[dataId])
    },
    getMenus() {
        return axios.get(path.baseUrl + path.menus)
    },
    getUserInfo() {
        return axios.get(path.baseUrl + path.userInfo)
    },
    getLoginCaptchaToken() {
        return axios.get(path.baseUrl + path.loginCaptchaToken)
    },
    login(data) {
        return axios.post(path.baseUrl + path.login, data)
    },
    logout() {
        return axios.get(path.baseUrl + path.logout)
    },
    updateSystemConfig(data) {
        return axios.post(path.baseUrl + path.updateSystemConfig, data);
    },
    getSystemConfig(keys) {
        return axios.get(path.baseUrl + stringFormat(path.getSystemConfig, [keys]))
    },
    updateImageValue(data) {
        return axios.post(path.baseUrl + path.updateImageValue, data);
    },
    getEnumOptionList(enumIndex, sort = false, refId = '') {
        return axios.get(path.baseUrl + stringFormat(path.getEnumOptionList, [enumIndex, sort, refId]))
    },
    deleteUser(userId) {
        return axios.get(path.baseUrl + stringFormat(path.deleteUser, [userId]))
    },
    getDifficultySettings() {
        return axios.get(path.baseUrl + path.getDifficultySettings)
    },
    updateSubjectSetting(data) {
        return axios.post(path.baseUrl + path.updateSubjectSetting, data);
    },
    getEditorParams() {
        return axios.get(path.baseUrl + path.getEditorParams)
    },
    getUser4select() {
        return axios.get(path.baseUrl + path.getUser4select)
    },
    createMaterial(data) {
        return axios.post(path.baseUrl + path.createMaterial, data);
    },
    listMaterial(data) {
        return axios.post(path.baseUrl + path.listMaterial, data);
    },
    getMaterial4Edit(mid) {
        return axios.get(path.baseUrl + stringFormat(path.getMaterial4Edit, [mid]))
    },
    deleteMaterial(mid) {
        return axios.get(path.baseUrl + stringFormat(path.deleteMaterial, [mid]))
    },
    downloadAsZipFile(mid = false) {
        return axios.get(path.baseUrl + stringFormat(path.downloadAsZipFile, [mid]))
    },
    getMaterial(mid) {
        return axios.get(path.baseUrl + stringFormat(path.getMaterial, [mid]))
    },
    createEnumValue(data) {
        return axios.post(path.baseUrl + path.createEnumValue, data);
    },
    updateEnumValueEnableState(dataId, value) {
        return axios.get(path.baseUrl + stringFormat(path.updateEnumValueEnableState, [dataId, value]))
    },
    deleteDataStatistic(query) {
        return axios.get(path.baseUrl + path.deleteDataStatistic, {params: query})
    },
    updateAuthorCare(id) {
        return axios.get(path.baseUrl + stringFormat(path.updateAuthorCare, [id]))
    },
    updateAuthorUs(id) {
        return axios.get(path.baseUrl + stringFormat(path.updateAuthorUs, [id]))
    },
    getCareAuthorList() {
        return axios.get(path.baseUrl + path.getCareAuthorList)
    },
    getXhsNotes() {
        return axios.get(path.baseUrl + path.getXhsNotes)
    },
    getNoteData(noteId) {
        return axios.get(path.baseUrl + stringFormat(path.getNoteData, [noteId]))
    },
    queryCareNoteUpdate(noteUpdate) {
        return axios.get(path.baseUrl + stringFormat(path.queryCareNoteUpdate, [noteUpdate]))
    },
    deleteAuthor(id) {
        return axios.get(path.baseUrl + stringFormat(path.deleteAuthor, [id]))
    },
    updateEnumValue(data) {
        return axios.post(path.baseUrl + path.updateEnumValue, data);
    },
    getEnumValueById(id) {
        return axios.get(path.baseUrl + stringFormat(path.getEnumValueById, [id]))
    },
    getSiteConfigList(siteId) {
        return axios.get(path.baseUrl + stringFormat(path.getSiteConfigList, [siteId]))
    },
    createOrUpdateSiteConfig(data) {
        return axios.post(path.baseUrl + path.createOrUpdateSiteConfig, data);
    },
    updateSitePageVisible(query) {
        return axios.get(path.baseUrl + path.updateSitePageVisible, {params: query})
    },
    updateBannerEnableState(id,val) {
        return axios.get(path.baseUrl + stringFormat(path.updateBannerEnableState, [id,val]))
    },
    getSitePageById(pageId) {
        return axios.get(path.baseUrl + stringFormat(path.getSitePageById, [pageId]))
    },
    querySiteStyle(htmlId) {
        return axios.get(path.baseUrl + stringFormat(path.querySiteStyle, [htmlId]))
    },
    getCareNoteUpdateSwitch() {
        return axios.get(path.baseUrl + path.getCareNoteUpdateSwitch)
    },
    getPageVersions(htmlId) {
        return axios.get(path.baseUrl + stringFormat(path.getPageVersions, [htmlId]))
    },
    markHtmlEditing(query) {
        return axios.get(path.baseUrl + path.markHtmlEditing, {params: query})
    },
    exportPageStatistic(siteId) {
        return axios.get(path.baseUrl + stringFormat(path.exportPageStatistic, [siteId]))
    },
    revertDeletePage(id) {
        return axios.get(path.baseUrl + stringFormat(path.revertDeletePage, [id]))
    },
    getSiteCountDownList(siteId) {
        return axios.get(path.baseUrl + stringFormat(path.getSiteCountDownList, [siteId]))
    },
    deleteEnum(id) {
        return axios.get(path.baseUrl + stringFormat(path.deleteEnum, [id]))
    },
    deleteCountdownDate(dateId) {
        return axios.get(path.baseUrl + stringFormat(path.deleteCountdownDate, [dateId]))
    },
    deleteCountdownPage(dateId,pageId) {
        return axios.get(path.baseUrl + stringFormat(path.deleteCountdownPage, [dateId,pageId]))
    },
    addPageToCountDownDate(query) {
        return axios.get(path.baseUrl + path.addPageToCountDownDate, {params: query})
    },
    updateSchoolRecommendPage(query) {
        return axios.get(path.baseUrl + path.updateSchoolRecommendPage, {params: query})
    }
}

export default api;
